export default __webpack_public_path__ + "static/media/carriage.3c812daf.svg";